// src/pages/Solicitacoes/components/HiddenFileInputs.jsx
import React from 'react';

export default function HiddenFileInputs({
    inputImagemRef,
    inputNfRef,
    handleFotosChange,
    handleNfsChange,
}) {
    return (
        <>
            <input
                type="file"
                multiple
                accept="image/*"
                style={{display: 'none'}}
                ref={inputImagemRef}
                onChange={handleFotosChange}
            />
            <input
                type="file"
                multiple
                accept=".pdf,.jpg,.jpeg,.png"
                style={{display: 'none'}}
                ref={inputNfRef}
                onChange={handleNfsChange}
            />
        </>
    );
}
